/*
  UIComponents
  Main UI module that manages the availability of all UI-related components
*/

import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ActionBarModule } from '@component/action-bar';
import { ConfirmationModalModule } from '@component/confirmation-modal';
import { DataTableModule } from '@component/data-table';
import { DocumentViewerComponent } from '@app/shared/components/document-viewer';
import { HtmlToTextPipeModule } from '@pipe/html-to-text';
import { FlowMaterialModule } from '@app/flow-material.module';
import { FormSectionNameModule } from '@pipe/form-section-name';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MessageBoxModule } from '@component/message-box';
import { MomentDatePipeModule } from '@pipe/moment-date';
import { NumberHelper } from '@app/shared/helpers/number.helper';
import { PipesModule } from '@app/shared/pipes/pipes.modules';
import { WarningBannerModule } from '@component/warning-banner/warning-banner.module';

import { BuilderComponent } from './builder/builder.component';
import { FieldNotInGlobalOrgPipe } from './builder/field-not-in-global-org.pipe';
import { FormInfoModalComponent } from './workspace/form-info-modal';
import { ImportSectionsModalComponent } from './sidebar/import-sections-modal';
import { InputGridComponent } from './input-grid/input-grid.component';
import { MapperComponent } from './mapper/mapper.component';
import { RichtextEditorModule } from './richtext-editor/richtext-editor.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { WorkspaceComponent } from './workspace/workspace.component';

const components = [
  DocumentViewerComponent,
  ImportSectionsModalComponent,
  FormInfoModalComponent,
  InputGridComponent,
  MapperComponent,
  BuilderComponent,
  SidebarComponent,
  WorkspaceComponent
];

@NgModule({
    declarations: [components, FieldNotInGlobalOrgPipe],
    exports: components,
    imports: [
      ActionBarModule,
      CommonModule,
      ConfirmationModalModule,
      DataTableModule,
      DragDropModule,
      FlowMaterialModule,
      FormSectionNameModule,
      HtmlToTextPipeModule,
      InlineSVGModule,
      MatSnackBarModule,
      MessageBoxModule,
      MomentDatePipeModule,
      PipesModule,
      RichtextEditorModule,
      RouterModule,
      WarningBannerModule
    ],
    providers: [NumberHelper]
})
export class UIComponentsModule {}
